"use client";

import { Filters } from "@/types/filters";
import { countActiveFilters } from "@/utils/search/count-active-filters";
import { formatSlugToTitle } from "@/utils/string/slug-to-title";
import { useEffect } from "react";

export function SearchTitleUpdater({ filters }: { filters: Partial<Filters> }) {
	useEffect(() => {
		const activeFiltersCount = countActiveFilters(filters);
		const firstLocation = filters.locations?.[0];

		if (activeFiltersCount === 1 && firstLocation?.name) {
			const locationName = formatSlugToTitle(firstLocation.name).replace("Project", "").trim();
			// Current title: "0 Brokerage Properties in {locationName}, {cityName}"
			// New title: "{locationName} - 0 brokerage Properties"
			const delayedTitle = `${locationName} - 0 brokerage Properties`;

			const timeoutId = setTimeout(() => {
				document.title = delayedTitle;
			}, 5000);

			return () => clearTimeout(timeoutId);
		}
	}, [filters]);

	return null;
}
